import { Grid, Typography } from '@mui/material';
import Tippy from '@tippyjs/react';
import { UpsellInvestmentAdviceModal } from '../../../../../holistic-financial-advice/investments/InvestmentMixModals';
import { HelpOutline } from '@mui/icons-material';
import { Colors } from '../../../../../../themes';
import { t } from 'i18next';

const MobileUpsellSubtitle: React.FC = () => {
  return (
    <Grid
      size={12}
      sx={{
        display: 'inline-flex',
      }}>
      <Typography
        sx={{
          display: 'inline',
          textAlign: 'center',
          marginBottom: '50px',
          width: '100%',
        }}
        variant='p18'
        color='primary'>
        {t('AIPrecision')}
        <Grid sx={{ display: 'inline' }} ml={'5px'}>
          <Tippy
            placement='bottom'
            interactive={true}
            content={<UpsellInvestmentAdviceModal />}
            theme='light-nickels-theme'>
            <HelpOutline style={{ color: Colors.primaryBase, marginBottom: '-5px' }} />
          </Tippy>
        </Grid>
      </Typography>
    </Grid>
  );
};

export default MobileUpsellSubtitle;
